import React, { useState, useEffect } from "react";
import CFSelect from "./CFSelect";
import arePropsEqual from "../../../utils/arePropsEqual";

const CFFontFamilySelect = ({
  name,
  value,
  placeholder,
  callback,
  onChange,
  large = true,
}) => {
  let initialValue = value ? value : "Select a font";
  const [options, setOptions] = useState([]);
  const [selectValue, setSelectValue] = useState({
    value: initialValue,
    label: initialValue,
  });

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isInitialized) return;

    ctas.builder.fonts.initialize(function () {
      setOptions([
        {
          value: "",
          text: "Theme font",
          group: "System fonts",
        },
        ...window?.builder_fonts_dropdown,
      ]);
      setIsInitialized(true);
    });
  }, [isInitialized]);

  useEffect(() => {
    if (value !== undefined && value !== selectValue?.value) {
      setSelectValue({ value: value, label: value || "Select a font" });
    }
  }, [value]);

  function handleChange(selectedOption) {
    setSelectValue(selectedOption);
    const newValue = selectedOption?.value || "";

    if (callback) {
      callback(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  }

  return (
    <React.Fragment>
      <div className="w-full">
        <CFSelect
          className={large ? "smart-select" : ""}
          value={selectValue}
          placeholder={placeholder}
          options={options}
          onChange={handleChange}
          font_dropdown={true}
          font_dropdown_large={large}
          name={name}
        />
      </div>
    </React.Fragment>
  );
};

export default React.memo(CFFontFamilySelect, arePropsEqual);
